import * as React from 'react';
require('./style.css');

interface IProps {
	buttonText?: string;
	buttonIcon?: JSX.Element;
}

interface IState {
	show: boolean;
}

class DropdownMenu extends React.Component<IProps, IState> {
	private menuItemsNode: HTMLElement;
	private buttonNode: HTMLElement;

	constructor(props) {
		super(props);

		this.state = {
			show: false,
		};

		this.onButtonClick = this.onButtonClick.bind(this);
	}

	public componentDidMount() {
		document.addEventListener('click', this.handleClickOutside, true);
	}

	public componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside, true);
	}

	private handleClickOutside = (e) => {
		if (!this.buttonNode.contains(e.target) && !this.menuItemsNode.contains(e.target) && this.state.show) {
			this.setState({
				show: false,
			});
		}
	};

	private onButtonClick() {
		this.setState({
			show: !this.state.show,
		});
	}

	public render() {
		const { buttonText, children, buttonIcon } = this.props;
		const { show } = this.state;

		return (
			<div className="dropdownMenu">
				<div className="buttonContainer">
					<button
						ref={(node) => (this.buttonNode = node)}
						className={show ? 'active' : 'noactive'}
						type="button"
						onClick={this.onButtonClick}
					>
						{buttonIcon}
						{buttonText}
					</button>
				</div>
				<div
					ref={(node) => (this.menuItemsNode = node)}
					className="menuItemsContainer"
					style={{ display: show ? 'block' : 'none' }}
				>
					{children}
				</div>
			</div>
		);
	}
}
export { DropdownMenu };
